import { LazyQueryHookOptions } from '@apollo/client';

import {
  AudiencesQuery,
  AudiencesQueryVariables,
  useAudiencesLazyQuery,
  useAudienceSelectItemsLazyQuery,
} from '@occc/graphql';

import { transformDataToAudiencesArray } from './utils';

import { useLazyQuery } from '../utils';

export const useGetAudiencesLazy = (
  baseOptions?: LazyQueryHookOptions<AudiencesQuery, AudiencesQueryVariables>,
) => {
  const [executeQuery, response] = useLazyQuery<AudiencesQuery, AudiencesQueryVariables>(
    useAudiencesLazyQuery,
    baseOptions,
  );

  return {
    executeQuery,
    response: {
      ...response,
      data: response.data ? transformDataToAudiencesArray(response.data) : response.data,
    },
  };
};

export const useGetAudienceSelectItemsLazy = () => {
  const [executeQuery, response] = useLazyQuery(useAudienceSelectItemsLazyQuery);

  return {
    executeQuery,
    response: {
      ...response,
      data: response.data?.audiences.edges.map((e) => e.node),
    },
  };
};
